export default {
    subtitle: 'Cette fonctionnalité est en cours de développement.',
    title: 'Bientôt disponible',
    description: 'Cette page n\'est pas encore disponible. Revenez plus tard.',
}
